import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import axios from "axios";
import { Container, Row, Col } from "reactstrap";
import * as vars from "../../constants/constants";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { setHeaderTitle } from "../../actions/HeaderActions";
import { clearHistory } from "../../actions/HistoryActions";
import { getVideoOrChannelRelatedData } from "../../actions/PlayActions";
import { console_log, fromNow } from "../../utils/helper";
import { FormattedMessage } from "react-intl";
import { config } from "../../constants/domainConfig";
import { sendData } from "../../analytics/sendData";
import { Videos360 } from "../../constants/videos";
import { isMobio360Plus } from "../../constants/multiDomains";

const videoTitlesWithId = Videos360.reduce((agg, item) => {
  return [...agg, ...item.videos];
}, []).map((x) => ({ id: x.id, name: x.name }));

class History extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.clearHistory = this.clearHistory.bind(this);
  }
  componentDidMount() {
    sendData("", "", "video", "viewed");
    this.props.show();
    setTimeout(() => {
      this.props.hide();
    }, 1500);
    window.scrollTo(0, 0);
    const history = {
      en: "History",
      fr: "Histoire",
      ar: "سجل المشاهدات",
      cy: "Историја",
      ee: "Ajalugu",
      es: "Historial",
      el: "Ιστορικό",
      id: "Sejarah",
      si: "Zgodovina",
      pl: "Historia",
    };
    this.props.setHeaderTitle(history[config.lang]);
  }

  goToPlay(data, event) {
    event.preventDefault();
    if (data.channel) {
      this.props.history.push("/play/channel");
    } else {
      this.props.history.push(
        `/play/video/?vid=${data.video.id}&uid=${this.props.account.user.uid}`
      );
    }
    this.props.getVideoOrChannelRelatedData(data);
  }

  clearHistory() {
    axios
      .delete(vars.BASE_API_URL + "/history")
      .then((response) => {
        console_log(response);
      })
      .catch((error) => {
        console_log(error);
      });
    this.props.clearHistory();
  }

  render() {
    const deleteHistoryIcon =
      '<svg width="20" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59 59"><path fill="#b2a2c9" d="M29.5 51c.552 0 1-.447 1-1V17c0-.553-.448-1-1-1s-1 .447-1 1v33c0 .553.448 1 1 1zM19.5 51c.552 0 1-.447 1-1V17c0-.553-.448-1-1-1s-1 .447-1 1v33c0 .553.448 1 1 1zM39.5 51c.552 0 1-.447 1-1V17c0-.553-.448-1-1-1s-1 .447-1 1v33c0 .553.448 1 1 1z"/><path fill="#b2a2c9" d="M52.5 6H38.456c-.11-1.25-.495-3.358-1.813-4.711C35.809.434 34.751 0 33.499 0H23.5c-1.252 0-2.31.434-3.144 1.289C19.038 2.642 18.653 4.75 18.543 6H6.5c-.552 0-1 .447-1 1s.448 1 1 1h2.041l1.915 46.021C10.493 55.743 11.565 59 15.364 59h28.272c3.799 0 4.871-3.257 4.907-4.958L50.459 8H52.5c.552 0 1-.447 1-1s-.448-1-1-1zM21.792 2.681C22.24 2.223 22.799 2 23.5 2h9.999c.701 0 1.26.223 1.708.681.805.823 1.128 2.271 1.24 3.319H20.553c.112-1.048.435-2.496 1.239-3.319zm24.752 51.298C46.538 54.288 46.4 57 43.636 57H15.364c-2.734 0-2.898-2.717-2.909-3.042L10.542 8h37.915l-1.913 45.979z"/></svg>';
    const historyIconESMobile =
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#c23d43" d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/></svg>';
    return (
      <section className="history py-0">
        {window.innerWidth <= 575 ? (
          <button
            className="edit-button edit-button--history-icon"
            onClick={this.clearHistory}
            style={
              config.lang === "ar" ? { left: 20 + "px", right: "unset" } : {}
            }
          >
            <span dangerouslySetInnerHTML={{ __html: deleteHistoryIcon }} />
          </button>
        ) : (
          <button
            className="edit-button"
            onClick={this.clearHistory}
            style={
              config.lang === "ar" ? { left: 20 + "px", right: "unset" } : {}
            }
          >
            <FormattedMessage id="clear" defaultMessage="Clear" />
          </button>
        )}
        <Row>
          <Col xs="12">
            {(this.props.historyVideos.channels &&
              this.props.historyVideos.channels.length > 0) ||
            (this.props.historyVideos.videos &&
              this.props.historyVideos.videos.length > 0) ? (
              <ul className="list-unstyled video-list video-list--history">
                {this.props.historyVideos.channels
                  ? this.props.historyVideos.channels.map((channel) => {
                      return (
                        <li
                          key={channel.channelId}
                          className="video-list__item video-list__item--history"
                          onClick={this.goToPlay.bind(this, {
                            channel: channel,
                          })}
                        >
                          <div className="video-list__image video-list__image--history">
                            <div className="channels-image">
                              <div className="channels-image channels-image--genre channels-image--list no-radius">
                                <img
                                  className="channels-thumb__image no-radius"
                                  src={
                                    channel.channelImage
                                      ? vars.BASE_URL +
                                        "uploads/" +
                                        channel.channelImage
                                      : "./img/thumbnail-2.jpg"
                                  }
                                  alt={channel.channelName}
                                />
                                <img
                                  className="channels-thumb__icon channel-thumb__icon--list"
                                  src={channel.channelLogo}
                                  alt={channel.channelName}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="video-list__details video-list__details--history">
                            <div className="video-list__upper">
                              <div className="video-list__upper__left">
                                <h4 className="channels-thumb__name channels-thumb__name--list my-0">
                                  {channel.channelName}
                                </h4>
                                <span className="history-text">
                                  {channel.createdAt
                                    ? fromNow(channel.createdAt)
                                    : ""}
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      );
                    })
                  : ""}
                {this.props.historyVideos.videos
                  ? this.props.historyVideos.videos
                      .filter((x) =>
                        config.domain != "za" ? x.videoId < 750 : true
                      )
                      .map((video) => {
                        return (
                          <li
                            key={video.videoId}
                            className="video-list__item video-list__item--history"
                            onClick={this.goToPlay.bind(this, {
                              video: {
                                id: video.videoId,
                                name: video.name,
                                preview: video.preview,
                                duration: video.duration,
                              },
                            })}
                          >
                            <div className="video-list__image video-list__image--history">
                              <div className="channels-image">
                                <div className="channels-image channels-image--genre channels-image--list no-radius">
                                  <img
                                    className="channels-thumb__image no-radius"
                                    src={video.preview}
                                    alt={video.name}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="video-list__details video-list__details--history">
                              <div className="video-list__upper">
                                <div className="video-list__upper__left">
                                  <h4 className="channels-thumb__name channels-thumb__name--list my-0">
                                    {
                                      
                                      videoTitlesWithId.filter(x => x.id === video.videoId)[0] 
      ? videoTitlesWithId.filter(x => x.id === video.videoId)[0].name[config.lang] || "en"
      : "en"
                                    }
                                  </h4>
                                  {config.lang === "ar" ? (
                                    "من" +
                                    ` ${(Math.random() * 10 + 1).toFixed(0)} ` +
                                    "ساعات"
                                  ) : (
                                    <span className="history-text">
                                      {(Math.random() * 10 + 1).toFixed(0)}
                                      <FormattedMessage
                                        id="hoursAgo"
                                        defaultMessage="Hours Ago"
                                      />
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      })
                  : ""}
              </ul>
            ) : (
              <div className="no-data-text-center">
                <p className="no-data-history-icon">
                  <span
                    dangerouslySetInnerHTML={{ __html: historyIconESMobile }}
                  />
                </p>
                <h4 className="favorites__pane__title">
                  <FormattedMessage
                    id="noHistory"
                    defaultMessage="No History Videos Yet"
                  />
                </h4>
              </div>
            )}
          </Col>
        </Row>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    account: state.AccountReducer,
    category: state.CategoryReducer,
    country: state.CountryReducer,
    domain: state.DomainReducer,
    favorite: state.FavoriteReducer,
    flashmessage: state.FlashMessageReducer,
    header: state.HeaderReducer,
    historyVideos: state.HistoryReducer,
    loader: state.ActivityIndicatorReducer,
    play: state.PlayReducer,
    smartTV: state.SmartTVReducer,
    splash: state.SplashScreenReducer,
    user: state.AuthenticationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      show,
      hide,
      setHeaderTitle,
      clearHistory,
      getVideoOrChannelRelatedData,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(History);



// WEBPACK FOOTER //
// ./src/components/History/History.js